import {
  type FlowSecureHeaderCreateBody,
  type FlowSecureHeaderListQuery,
  type FlowSecureHeaderUpdateBody,
} from 'flow-schema';

import { type Common } from '../common.js';
import { type SecureHeader } from '../models/flow/secureHeaders.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/secure-headers';

  constructor(common: Common) {
    this.common = common;
  }

  async create(body: FlowSecureHeaderCreateBody): Promise<SecureHeader> {
    const url = this.common.constructPath(`${this.baseEndpoint}/`);
    return await this.common.postJSON(url, body);
  }

  async updateOneHeaderValueById(id: string, headerValue: string): Promise<void> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}/secure-header-value`);
    return await this.common.patchJSON(url, { secureHeaderValue: headerValue });
  }

  async updateOneById(id: string, body: FlowSecureHeaderUpdateBody): Promise<SecureHeader> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, body);
  }

  async findOneById(id: string): Promise<{ secureHeader: SecureHeader }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async findAll(params?: FlowSecureHeaderListQuery): Promise<SecureHeader[]> {
    const url = this.common.constructPath(`${this.baseEndpoint}/`, params);
    return await this.common.getJSON(url);
  }

  async deleteOneById(id: string): Promise<{ deleted: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
